import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { scrollToElement } from '@project/shared/utils/scroll-to/js/scroll-to';

import 'select2'; // globally assign select2 fn to $ element

const classes = {

	submitForm: 'js-form__button-event--submit',
	cancelForm: 'js-form__button-event--cancel',
	focusElement: 'js-form__event-show-additional-fields',
	additionalFields: 'js-form__additional-fields',
	stateFormOrderAdditionalFieldsVisible: 'state-m-stage-keyvisual-search--show-additional-fields',
	stateFormOrderHiddenAfterSubmit: 'state-m-stage-keyvisual-search--hidden-after-submit',
	inputSelect: 'js-form__input-select',
	input: 'js-form__input',
	inputCheckBox: 'a-input-checkbox__input',
	inquiryTypeInputSelect: "js-form__input-inquiry-type",
	sdsLinkColumn: "js-o-form__grid-col-sds-link",
	inquiryTextboxColumn: "js-o-form__grid-col-inquiry-textbox",

	inputSelectCategoryType: "js-form__input-category-type",
	inputSelectCheckMark: 'a-input-select--global-has-check',
	categoryInputContainer: "o-form__grid-col--input-category",
	categoryInputField: 'js-a-input--category',
	inputSearchbox: 'js-m-stage-keyvisual-search__search-input',
};

const optionValues = {
	other: "other",
	productSafetyDataSheets: "product safety data sheets"
}

@createModule('StageSearchNew')
/**
 * stage-keyvisual-search module implementation.
 *
 * @author Robert Schork <robert.schork@namics.com>
 */
export class StageSearchNew extends TerrificSpec {
	$ctx: JQuery;
	$inputSelect: JQuery;
	$inputCheckBox: JQuery;
	$input: JQuery;
	$inputElement: JQuery;
	focusFromScrollReached: boolean = false;

	start(resolve: () => void) {
		this.$ctx = $(this._ctx);
		const formID = this.$ctx.attr('id');
		this.initFormHadling();
		this.onClickAnchor();

		this.onClickLink($('.js-m-stage-product__button'));
		if ($('.js-m-stage-product__button').length > 0) {
			this.onClickLink($('.js-m-navigation-in-page__cta'));
		}

		$('.js-m-navigation-in-page__list-items').on("click", '[href="#' + formID + '"]', (ev: Event) => {
			ev.preventDefault();
			this.onFocusAreaFocus();
			this.$ctx.find(`.${classes.focusElement}`).focus();
		});

		if (this.$ctx.data('api-endpoint')) {
			this.prefillFormData();
		}

		this.$inputSelect = this.$ctx.find(`.${classes.inputSelect}`);
		this.$inputCheckBox = this.$ctx.find(`.${classes.inputCheckBox}`);
		this.$input = this.$ctx.find(`.${classes.input}`);
		this.$inputSelect.on('change', (ev: Event) => this.inputSelecteOptionChanged(ev));
		this.addOtherOptionForMaterialTag();
		this.setMaterialTagDefaultValue();
		this.$inputElement = this.$ctx.find(`.${classes.inputSearchbox}`);
		this.$inputElement.on('keyup', this._handleInputChange.bind(this));

		resolve();
	}

	initFormHadling() {
		this.$ctx.on('focus', `.${classes.focusElement}`, this.onFocusAreaFocus.bind(this));
		this.$ctx.on('click', `.${classes.cancelForm}`, this.onCancleClick.bind(this));
		this.$ctx.on('click', `.${classes.submitForm}`, this.onFormSubmit.bind(this));
	}

	onFocusAreaFocus() {
		this.$ctx.find(`.${classes.additionalFields}`).addClass(classes.stateFormOrderAdditionalFieldsVisible);
		if (!this.focusFromScrollReached) {
			if ($('.js-m-navigation-in-page__wrapper').length > 0) {
				scrollToElement(this.$ctx, true, $('.js-m-navigation-in-page__wrapper').height() + 20);
			} else {
				scrollToElement(this.$ctx, true, 70);
			}
		} else {
			this.focusFromScrollReached = false;
		}
		$(window).trigger('NavigationInPage:reInitNoClick');
	}

	_handleInputChange(event: any) {
		let inputString = this.$inputElement.val() as string;
		let $searchLink = $(this.$ctx).find('.js-m-stage-keyvisual-search__search-btn');
		let newLinkUrl = $searchLink.data('baseurl') + inputString;

		if (event.keyCode == 13) {
			window.location.href = newLinkUrl;
		}

		$searchLink.attr('href', newLinkUrl);
	}

	onCancleClick() {
		this.$ctx.find(`.${classes.additionalFields}`).removeClass(classes.stateFormOrderAdditionalFieldsVisible);
		scrollToElement(this.$ctx, true);
	}

	onFormSubmit(ev: Event) {
		const $materialTag: any = this.$ctx.find('select[data-sc-field-name="materialTag"]');
		var validate = true;
		this.$inputSelect.each(function (index, item) {
			var dataValRequired = $(item).attr("data-val");
			if (typeof dataValRequired !== "undefined" && dataValRequired !== "" && dataValRequired !== null) {
				if ($(item).val() == "") {
					$(item).addClass("state-a-input--has-error");
					$(item).nextAll('.field-validation-valid').text($(item).attr("data-val-required"));
					$(item).nextAll('.field-validation-valid').addClass('field-validation-error');
					validate = false;
				}
			}
		});

		this.$input.each(function (index, item) {
			var dataValRequired = $(item).attr("data-val");
			if (typeof dataValRequired !== "undefined" && dataValRequired !== "" && dataValRequired !== null) {
				if ($(item).val() == "") {
					$(item).addClass("input-validation-error");
					$(item).nextAll('.field-validation-valid').addClass('field-validation-error');
					$(item).nextAll('.field-validation-valid').text($(item).attr("data-val-required"));
					validate = false;
				}
			}
		});

		this.$inputCheckBox.each(function (index, item) {
			var dataValRequired = $(item).attr("data-val");
			if (typeof dataValRequired !== "undefined" && dataValRequired !== "" && dataValRequired !== null) {
				if (!$(item).is(':checked')) {
					$(item).addClass("input-validation-error");
					validate = false;
				}
			}
		});

		if (!validate) {
			ev.preventDefault();
		}
		this.$ctx.addClass(classes.stateFormOrderHiddenAfterSubmit);
	}

	/*onScrollReached() {  //remove feature again due to customer request
		this.focusFromScrollReached = true;
		this.$ctx.find(`.${classes.focusElement}`).focus();
	}*/

	onClickAnchor() {
		const formID = this.$ctx.attr('id');
		$('[href="#' + formID + '"]')
			.unbind("click")
			.on("click", (ev: Event) => {
				ev.preventDefault();
				this.onFocusAreaFocus();
				this.$ctx.find(`.${classes.focusElement}`).focus();
			});
	}

	onClickLink($el: JQuery) {
		const formID = this.$ctx.attr('id');
		$el.on('click', (ev: JQuery.Event) => {
			ev.preventDefault();
			const url = $el.attr('href');
			const anchorIdx = url.indexOf('#' + formID);
			if (anchorIdx != -1) {
				this.onFocusAreaFocus();
				this.$ctx.find(`.${classes.focusElement}`).focus();
			}
		});
	}

	prefillFormData() {
		const serviceUrl = this.$ctx.data('api-endpoint');

		if (serviceUrl) {
			$.ajax({
				method: 'get',
				url: serviceUrl,
				success: (jsonData: any) => {
					for (let key in jsonData) {
						const $input = this.$ctx.find('input[data-sc-field-name="' + key + '"]');
						$input.val(jsonData[key]);
						$input.trigger('change');
					}
				},
			});
		}
	}

	inputSelecteOptionChanged(ev: any) {
		const opt: string = ev.currentTarget.value.toLowerCase();
		const $target: any = $(ev.currentTarget);

		if ($target.val() !== "") {
			$target.removeClass("state-a-input--has-error");
			$target.nextAll('.field-validation-valid').text("");
			$target.nextAll('.field-validation-valid').removeClass('field-validation-error');
		}
		else {
			var dataValRequired = $target.attr("data-val");
			if (typeof dataValRequired !== "undefined" && dataValRequired !== "" && dataValRequired !== null) {
				$target.addClass("state-a-input--has-error");
				$target.nextAll('.field-validation-valid').text($target.attr("data-val-required"));
				$target.nextAll('.field-validation-valid').addClass('field-validation-error');
			}
		}
		// Inquiry Type dropdown
		if ($target.hasClass(classes.inquiryTypeInputSelect)) {

			const $sdsLinkCol: any = this.$ctx.find(`.${classes.sdsLinkColumn}`);
			const $sdsTextboxCol: any = this.$ctx.find(`.${classes.inquiryTextboxColumn}`);

			let showCheckMark = false;
			// show SDS link
			if (opt === optionValues.productSafetyDataSheets) {
				$sdsLinkCol.css("display", "flex");
				showCheckMark = true;
			} else {
				$sdsLinkCol.css("display", "none");
			}

			// show SDS textbox
			if (opt === optionValues.other) {
				$('input[data-sc-field-name="otherInquiryType"]').val("");
				$sdsTextboxCol.show();
				showCheckMark = true;
			}
			else {
				$('input[data-sc-field-name="otherInquiryType"]').val("-");
				$sdsTextboxCol.hide();
			}

			if (showCheckMark) {
				$target.addClass(classes.inputSelectCheckMark);
			} else {
				$target.removeClass(classes.inputSelectCheckMark);
			}
		}

		// Category Type dropdown
		if ($target.hasClass(classes.inputSelectCategoryType)) {

			const $categoryInputContainer: any = this.$ctx.find(`.${classes.categoryInputContainer}`);
			const $firstInput: any = this.$ctx.find(".a-input-first .js-a-input--first-name");

			if (opt === optionValues.other.toLowerCase()) {
				$('input[data-sc-field-name="OtherCategory"]').val("");
				$categoryInputContainer.show();
				$target.addClass(classes.inputSelectCheckMark);
				setTimeout(() => {
					$categoryInputContainer
						.find(classes.categoryInputField)
						.focus()
						.select();
				}, 150);

			} else {
				$('input[data-sc-field-name="OtherCategory"]').val("-");
				$categoryInputContainer.hide();
				$target.removeClass(classes.inputSelectCheckMark);
				if ($firstInput.length > 0) {
					setTimeout(() => {
						if ($firstInput.val().length < 1) {
							$firstInput.focus().select();
						}
					}, 150);
				}
			}
		}

	}

	/**
	 * Add Other Optioin For MaterialTag field
	 * @returns {void}
	 */
	addOtherOptionForMaterialTag() {
		var otherText = $('#OtherText').val();
		var otherValue = $('#OtherValue').val();
		const $materialTag: any = this.$ctx.find('select[data-sc-field-name="materialTag"]');

		if ($materialTag.length > 0) {
			$('select[data-sc-field-name="materialTag"]').append(`<option value="${otherValue}" data-select2-id="10000">${otherText}</option>`);
		}
	}

	setMaterialTagDefaultValue() {
		var urlParams = new URLSearchParams(window.location.search);
		var meterialTag = $('#SelectTag').val();
		if (urlParams.has('materialtag')) {
			meterialTag = urlParams.get('materialtag');
		}
		$('select[data-sc-field-name="materialTag"]').val(meterialTag);
	}
	stop() { }
}
